import { makeStyles } from '@material-ui/core/styles'

import { lightGrey } from '../utils/colors'

export const videoLibraryContainer = makeStyles({
    container: {
        width: '100%',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexDirection: 'row',
        paddingRight: 30,
        paddingLeft: 30
    },
    smallText: {
        padding: 0,
        fontWeight: 300,
        color: lightGrey
    },
    formControl: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start'
    },
    switch: {
        color: '#28a745'
    },
    innerContainer: {
        width: '100%',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexDirection: 'row'
    },
    buttonContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    questionContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        marginBottom: 25
    },
    plusButton: {
        marginLeft: 10
    }
})
